// Home.js
// import React from 'react';
// import { Link } from 'react-router-dom';
// import '../Styles/Pages/Home.css';

// const Home = () => {
//     // Simple version without Okta authentication for now
//     return (
//         <div className="home-container">
//             <div className="welcome-section">
//                 <h1>Welcome to Casino Portal USA</h1>
//                 {/* <p></p> */}
//             </div>

//             <div className="cta-section">
//                 <div className="auth-buttons">
//                     <Link to="/login" className="login-button">
//                         Login
//                     </Link>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Home;


// Home.js
// Home.js
import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Link } from 'react-router-dom';
import '../Styles/Pages/Home.css';

const Home = () => {
    const { authState } = useOktaAuth();

    return (
        <div className="home-container">
            <div className="welcome-section">
                <h1>Welcome to Casino Portal USA</h1>
                {/* You can uncomment this if you want to add a description */}
                {/* <p>Your gateway to casino information and resources</p> */}
            </div>

            <div className="cta-section">
                {!authState?.isAuthenticated ? (
                    <div className="auth-buttons">
                        <Link to="/login" className="login-button">
                            Login
                        </Link>
                    </div>
                ) : (
                    <div className="welcome-back">
                        <h2>Welcome back!</h2>
                        {/* <p>You're already logged in. Visit your dashboard to continue.</p> */}
                        <Link to="/Information" className="dashboard-button">
                            Go to Casino Information
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;